import React, { useEffect, useState } from 'react';
import PlaysPricingPage from './PlaysPricingPage';
import { fetchEntitlements } from './playsApi';
import { useI18n } from '../../context/i18n';
import { playsTranslations } from './playsCopy';
import './PlaysView.css';

// Top-level Plays/Billing view wired into App.js's currentView router,
// replacing the old slots-model BillingView. Shows checkout result banner
// (from the Shopify Billing returnUrl, see plays_routes.billing_callback:
// /billing?status=active|error|reauth&plan=...) above the pricing page.
export default function PlaysView({ token, checkoutResult, onDismissCheckoutResult }) {
  const { language } = useI18n();
  const copy = playsTranslations[language]?.checkout || playsTranslations.en.checkout;

  const [entitlements, setEntitlements] = useState(null);

  const checkoutStatus = checkoutResult?.status || null;
  const isCheckoutSuccess = checkoutStatus === 'active';
  const checkoutMessage = checkoutStatus
    ? (isCheckoutSuccess ? copy.success : checkoutStatus === 'reauth' ? copy.reauth : copy.error)
    : null;

  useEffect(() => {
    if (!token) return;
    fetchEntitlements({ token, refresh: isCheckoutSuccess })
      .then(setEntitlements)
      .catch(() => {
        // Pricing page still renders from the public /billing/plans catalog.
      });
  }, [token, isCheckoutSuccess]);

  return (
    <div className="plays-view">
      {checkoutMessage && (
        <div className={`plays-view-checkout-banner ${isCheckoutSuccess ? 'is-success' : 'is-error'}`} role="status">
          <span>{checkoutMessage}</span>
          <button type="button" className="plays-view-checkout-dismiss" onClick={onDismissCheckoutResult}>
            {isCheckoutSuccess ? copy.dismiss : copy.retry}
          </button>
        </div>
      )}
      <PlaysPricingPage
        token={token}
        currentPlanTier={entitlements?.plan || 'free'}
        currentPlanPacks={entitlements?.play_packs || 0}
        isFounding={Boolean(entitlements?.founding)}
      />
    </div>
  );
}
